import { useSettingsStore } from '../store'
import { Ticket } from 'lucide-react'

export function JiraPromptsTab() {
  const { jiraPrompts, updateJiraPrompt } = useSettingsStore()

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Ticket className="text-primary" size={20} />
        <div>
          <h2 className="text-lg font-medium text-[var(--text-primary)]">Jira Ticket Prompts</h2>
          <p className="text-sm text-[var(--text-muted)]">
            Configure the AI prompts used to generate Jira ticket content from scope settings.
            These prompts are sent along with the scope data when you click &quot;Create Jira Ticket&quot;.
          </p>
        </div>
      </div>

      {/* V1 Prompt */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-[var(--text-primary)]">
          V1 Prompt
        </label>
        <p className="text-xs text-[var(--text-muted)]">
          Used when generating a Jira ticket for V1 API scopes. Include instructions on the expected
          output format, sections, and any V1-specific details.
        </p>
        <textarea
          value={jiraPrompts.v1Prompt}
          onChange={(e) => updateJiraPrompt('v1Prompt', e.target.value)}
          rows={12}
          placeholder="Enter the V1 Jira ticket generation prompt..."
          className="w-full rounded-lg border border-[var(--border-color)] bg-[var(--bg-secondary)] px-3 py-2 text-sm text-[var(--text-primary)] placeholder:text-[var(--text-muted)] focus:outline-none focus:ring-2 focus:ring-[var(--accent-color)]/50 focus:border-[var(--accent-color)] resize-y font-mono"
        />
      </div>

      {/* V2 Prompt */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-[var(--text-primary)]">
          V2 Prompt
        </label>
        <p className="text-xs text-[var(--text-muted)]">
          Used when generating a Jira ticket for V2 API scopes. Include instructions on the expected
          output format, sections, and any V2-specific details.
        </p>
        <textarea
          value={jiraPrompts.v2Prompt}
          onChange={(e) => updateJiraPrompt('v2Prompt', e.target.value)}
          rows={12}
          placeholder="Enter the V2 Jira ticket generation prompt..."
          className="w-full rounded-lg border border-[var(--border-color)] bg-[var(--bg-secondary)] px-3 py-2 text-sm text-[var(--text-primary)] placeholder:text-[var(--text-muted)] focus:outline-none focus:ring-2 focus:ring-[var(--accent-color)]/50 focus:border-[var(--accent-color)] resize-y font-mono"
        />
      </div>

      <p className="text-xs text-[var(--text-muted)]">
        Changes are saved automatically.
      </p>
    </div>
  )
}
